export const kingaIwanska = {
    'meta': {
        'title': 'Psycholog, psychoterapeuta dzieci i młodzieży Kinga Iwanska',
        'description': 'Jestem psychologiem, trenerem TUS oraz psychoterapeutą w trakcie specjalizacji. Od blisko 10 lat pracuję z dziećmi i młodzieżą z Zespołem Aspergera.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psycholog-psychoterapeuta-kinga-iwanska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/kinga-iwanska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Bydgoszczy, Psychoterapeuta w Bydgoszczy Kinga Iwanska'
        }
    }
}